import L from "leaflet";

export function removeMapLayersById(map: L.Map | null, ids: string[]) {
  if (!map || !ids?.length) return;

  const idSet = new Set(ids);

  map.eachLayer((layer) => {
    const layerId = (layer.options as any)?.id;
    if (idSet.has(layerId)) {
      map.removeLayer(layer);
    }
  });
}
